import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

// third party module import
import { ToastrModule } from 'ngx-toastr';

// custom module import
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { LayoutModule } from '@app/layout/layout.module';


// custom component import
import { AppComponent } from './app.component';

import { AppRoutes } from './app.routing';

// custom service import
import { ApiService, AuthService, SharedService } from './shared/services';
import { AccessGuard } from './shared/security';
import { AuthGuard } from '@app/core';
import { CompareProgramsComponent, PortfolioComponent, AboutComponent, ContactComponent, HomeComponent } from './modules';
import { AngularFullpageModule } from '@fullpage/angular-fullpage';
import { ProgramService } from './modules/shared/services/program.service';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ContentSharedModule } from '@app/modules/shared';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    AppComponent,
    CompareProgramsComponent,
    PortfolioComponent,
    AboutComponent,
    ContactComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, {useHash: false}),
    AngularFullpageModule,
    SlickCarouselModule,
    // third-party modules
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),

    // core & shared
    CoreModule,
    SharedModule,
    ContentSharedModule,
    InfiniteScrollModule,

    // layout
    LayoutModule,
  ],
  providers: [
    AccessGuard,
    ApiService,
    AuthService,
    AuthGuard,
    SharedService,
    ProgramService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
